<script setup lang="ts">
import {
  iMenu,
  iMenuItem,
  iButton,
  iButtonTypes,
  iButtonStyles,
  iButtonSizes,
  iMenuTriggerAlignOptions,
} from '@inscribe/signal';
import type { FilterOption } from '@/types/decision-engine/configurable-insights.types';

interface Props {
  availableFilters: FilterOption[];
  triggerAlign?: iMenuTriggerAlignOptions;
}

interface Emits {
  (e: 'add-filter', value: string): void;
}

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <i-menu
    v-if="availableFilters.length > 0"
    :trigger-align="triggerAlign ?? iMenuTriggerAlignOptions.LEFT"
  >
    <template #trigger>
      <i-button
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.SOLID_LIGHT"
        :size="iButtonSizes.MEDIUM"
        text="Add Filter"
      />
    </template>
    <template #items>
      <i-menu-item
        v-for="filter in availableFilters"
        :key="filter.value"
        :label="filter.text"
        :disabled="filter.disabled ?? false"
        @item-click="!filter.disabled && emit('add-filter', filter.value)"
      />
    </template>
  </i-menu>
</template>
